import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      gridArea: 'upload',
      overflow: 'initial',
      height: 'auto',
    },
  },
  inner: {
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    padding: 10,
    [theme.breakpoints.down('sm')]: {
      overflow: 'initial',
      height: 'auto',
      padding: 0,
    },
  },
}))

export default useStyles
